import { render } from "./UserDialogButton.vue?vue&type=template&id=fe18fb08&scoped=true&ts=true"
import script from "./UserDialogButton.vue?vue&type=script&lang=ts"
export * from "./UserDialogButton.vue?vue&type=script&lang=ts"

import "./UserDialogButton.vue?vue&type=style&index=0&id=fe18fb08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe18fb08"]])

export default __exports__